import { AlertTriangle, Infinity as InfinityIcon } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';
import { Spinner } from '@/components/ui/Spinner';
import { AdsProviderDashboard } from './ads-report/AdsProviderDashboard';
import { useMetaAdsEnabled } from './metaAds';

/**
 * Meta Ads (Facebook + Instagram) campaigns, spend and conversions. Only for
 * accounts with the Marketing module's Meta Ads opt-in switched on.
 */
export default function MetaAdsPage() {
  const { enabled, known, failed, retry } = useMetaAdsEnabled();
  if (failed) {
    // Without this the spinner below would never end: the modules query does
    // not retry on its own.
    return (
      <div className="p-6">
        <EmptyState
          icon={<AlertTriangle className="h-8 w-8 text-amber-500" />}
          title="Couldn’t check whether Meta Ads is enabled"
          description="Your account settings did not load. Check your connection and try again."
          action={{ label: 'Try again', onClick: retry }}
        />
      </div>
    );
  }
  if (!known) {
    return <div className="flex h-64 items-center justify-center"><Spinner /></div>;
  }
  if (!enabled) {
    return (
      <div className="p-6">
        <EmptyState
          icon={<InfinityIcon className="h-8 w-8 text-slate-400" />}
          title="Meta Ads is not enabled for this account"
          description="Ask your Prospera contact to switch on Meta Ads for your practice."
        />
      </div>
    );
  }
  return (
    <AdsProviderDashboard
      provider="meta"
      title="Meta Ads"
      subtitle="Facebook and Instagram campaigns, spend and conversions"
      icon={<InfinityIcon className="h-4 w-4 text-[#0866FF]" aria-hidden="true" />}
      colors={{ primary: '#0866FF', secondary: '#F59E0B', palette: ['#0866FF', '#5B9BFF', '#9F7AEA', '#EC4899', '#F59E0B', '#CBD5E1'] }}
      tone="blue"
    />
  );
}
